<template>
  <div>
    <div class="bg">
      <FxedTop></FxedTop>
      <div class="pageTitle">
        <div class="sort"></div>
        <div class="currentLocation">当前位置：首页 > 证书查询</div>
      </div>
      <div class="main">
        <div class="title">继续教育证书查询</div>
        <input
          class="input"
          v-model="form.idCardNo"
          placeholder="请输入身份证号" />
        <input class="input" v-model="form.name" placeholder="请输入姓名" />
        <button class="search" @click="handleQueryCertificate">查询</button>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import {
  queryCertificate,
  pageMyClassGroupList,
  getMyCertificate,
} from "@/api/wkApi.js";
import FxedTop from "@/components/FxedTop.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: {
    FxedTop,
    Footer,
  },
  data() {
    return {
      form: {
        certificateNo: "",
        idCardNo: "",
        name: "",
      },
      indicatorDots: true,
      indicatorco: "rgba(0, 0, 0, .3)",
      indicatorac: "#000",
      vertical: false,
      autoplay: true,
      interval: 5000,
      duration: 1000,
      userInfo: {},
      curriculumList: [],
      inputValue: "",
      userCurriculum: {},
      marginT: 0,
      tipText: "暂无课程",
      titleArray: ["最新更新", "浏览量", "开课时间", "价格"],
      titleIndex: 0,
      courseList: [],
      myCertificateList: [],
    };
  },
  created() {
    this.selectUser();
    // this.getMyCertificate();
  },
  methods: {
    // getMyCertificate() {
    //   getMyCertificate().then((res) => {
    //     console.log(res);
    //     this.myCertificateList = res.result;
    //   });
    // },
    async selectUser() {
      try {
        let res = await pageMyClassGroupList({
          pageNum: 1,
          pageSize: 200,
        });
        var arr = res.result.records || [];
        this.courseList = arr;
      } catch {}
    },
    handleQueryCertificate() {
      if (!this.form.idCardNo) {
        return this.$message({
          message: "请输入身份证号",
          type: "error",
          duration: 5000, // Display for 5 seconds
        });
      }
      if (!this.form.name) {
        return this.$message({
          message: "请输入姓名",
          type: "error",
          duration: 5000, // Display for 5 seconds
        });
      }
      queryCertificate(this.form).then((res) => {
        console.log(res);
        if (res.result) {
          this.$router.push("/myCertificate");
        } else {
          console.log(this.courseList);
          if (this.courseList.length >= 1) {
            this.$message({
              message: "学员学时不够, 无法查询证书",
              type: "error",
              duration: 5000, // Display for 5 seconds
            });
          } else {
            this.$message({
              message: "学员暂未购买课程, 无法查询证书",
              type: "error",
              duration: 5000, // Display for 5 seconds
            });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  width: 1200px;
  height: 710px;
  background: #ffffff;
  border: 1px solid #0d6fc2;
  margin: 0 auto;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  .title {
    font-weight: bold;
    font-size: 40px;
    color: #0d6fc2;
    text-align: center;
    margin-bottom: 50px;
  }
  .input {
    display: block;
    width: 900px;
    height: 68px;
    background: #f5f5f5;
    border: none;
    padding-left: 40px;
    font-size: 20px;
    margin-bottom: 30px;
  }
  .search {
    display: block;
    width: 500px;
    height: 68px;
    background: linear-gradient(#41a0f1 0%, #0a5b9f 100%);
    line-height: 68px;
    
    font-weight: 400;
    font-size: 24px;
    color: #ffffff;
    border: none;
    margin-bottom: 20px;
    border-radius: 68px;
    cursor: pointer;
  }
  .text {
    
    font-weight: 400;
    font-size: 20px;
    color: #0d6fc2;
    line-height: 28px;
    text-align: right;
    font-style: normal;
  }
}
</style>
